<template>
  <div>
    <v-toolbar dark class="datModalTitleContainer">
      <v-toolbar-title>
        {{ $t("validateDesc") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon dark @click="fVolverAtras()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <p v-if="message.length > 0" class="px-3 py-2 alertText" v-html="message"></p>
      <v-textarea v-model="dComments" :disabled="dDisabled" :placeholder="$t('observationDesc')" rows="3"
        color="datPrimary"></v-textarea>
    </v-card-text>
    <v-flex v-if="dDisabled != true" class="px-3 pb-3">
      <v-layout row wrap class="ma-0" justify-center>
        <v-flex v-for="item in dBtns" :key="item.filtro" text-xs-center xs4 class=" px-2">
          <v-btn :class="item.class" flat block @click="fValidarRechazar(item)">{{ item.btnText }}</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </div>
</template>
<script>

import ServiceRecogidasEntregas from '@/services/srv-recogidas-entregas'

export default {
  data() {
    return {

      dBtns: [

        {
          btnText: this.$t('validate'),
          tipo: 'validar',
          action: 'S',
          class: 'datOkBtn'
        },
        {
          btnText: this.$t('cancel'),
          tipo: 'rechazar',
          action: 'N',
          class: 'datErrorBtn'
        }
      ],
      dDisabled: false,
      dComments: '',
      dUsuarioValidacion: '',
      dFechaValidación: ''
    }
  },
  props: {
    pPedidoSeleccionado: {
      type: Object,
      required: false,
      default: null
    }

  },
  mounted() {
    if (this.pPedidoSeleccionado && this.pPedidoSeleccionado !== null) {
      this.fInitVariables()
    }

  },
  methods: {
    fVolverAtras() {
      this.$emit('cerrar')
    },
    fValidarRechazar(item) {
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: this.pPedidoSeleccionado.item.Cliente,
        sucursal: this.pPedidoSeleccionado.item.codSucursal ? Number(this.pPedidoSeleccionado.item.codSucursal) : Number(this.pPedidoSeleccionado.item.Sucursal),
        albaran: this.pPedidoSeleccionado.item.Albaran,
        accion: item.action,
        comentario: this.dComments
      }
      ServiceRecogidasEntregas.setValidation(payload).then(response => {
        this.$emit('reload')
        this.fVolverAtras()
      })
    },
    fInitVariables() {
      if (this.pPedidoSeleccionado && this.pPedidoSeleccionado.item.validadoSN !== null) {
        this.dDisabled = true
        this.dComments = this.pPedidoSeleccionado.item.observaciones
        this.dUsuarioValidacion = this.pPedidoSeleccionado.item.usuarioValidacion
        this.dFechaValidación = this.pPedidoSeleccionado.item.fechaValidacion
      } else {
        this.dDisabled = false
        this.dComments = ''
        this.dUsuarioValidacion = ''
        this.dFechaValidación = ''
      }
    }
  },
  watch: {
    pPedidoSeleccionado: {
      handler(newValue, oldValue) {
        this.fInitVariables()
      },
      deep: true
    }
  },
  computed: {
    message() {
      if (this.pPedidoSeleccionado !== null && this.pPedidoSeleccionado.item.validadoSN !== null) {
        const fecha = new Date(this.dFechaValidación)
        const fechaFormateada = fecha.toLocaleDateString()
        const horaFormateada = fecha.toLocaleTimeString()
        const estado = this.pPedidoSeleccionado.item.validadoSN === 'S' ? 'validado' : 'anulado';
        const usuario = this.dUsuarioValidacion

        return `Servicio ${estado} el <b>${fechaFormateada}</b> a las  <b>${horaFormateada}</b> por el usuario <b>${usuario}.</b>`
      } else {
        return ''
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/EstadoRecogidas/ShpValidateService.vue